export { default } from "bullitttime-embercomponents/components/penalties";
